import { isWidthResize, debounce } from '../common/utils';

/**
 * @header_scroll
 */
export const initHeaderScroll = () => {
    const header = document.querySelector(`.header`);
    if (!header) return;
    let headerScrollHeight = 48 + 20 + 15;
    let scrollPos = 0;

    // Remove fixed class and remove all style changes
    function addHeaderScrolledClass() {
        header.classList.add(`scrolled`);
    }

    function removeHeaderScrolledClass() {
        header.classList.remove(`scrolled`);
    }

    // Change fixed class depending on document scrollTop
    function onWindowScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop >= headerScrollHeight) {
            addHeaderScrolledClass();
        } else {
            removeHeaderScrolledClass();
        }

        scrollPos = scrollTop;
    }

    function setFixedHeader() {
        const debouncedScroll = debounce(onWindowScroll, 100);
        window.removeEventListener(`scroll`, debouncedScroll);
        window.addEventListener(`scroll`, debouncedScroll);
    }

    function onLoad() {
        // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // if (scrollTop >= headerScrollHeight) {
        //     addHeaderFixedClass();
        // } else {
        //     removeHeaderFixedClass();
        // }
    }

    onLoad();
    setFixedHeader();
    isWidthResize(setFixedHeader);
};
